// extracted by mini-css-extract-plugin
export default {"dataCell":"DataCell_dataCell__Jhqnf","dataCell_highlighted":"DataCell_dataCell_highlighted__d-H6s","dataCell_bolded":"DataCell_dataCell_bolded__fFQ4p"};